
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';
import { useLocalStorage } from 'react-use';
import clsxm from '@/lib/clsxm';
import Footer from '@/components/layout/Footer';
import LandingPageNavigation from '@/components/layout/LandingPageNavigation';
import ButtonLink from '@/components/links/ButtonLink';
import Seo from '@/components/Seo';
const AiAvatar = () => {
    const router = useRouter();
    const { from } = router.query;
    const [fromValue] = useLocalStorage('from', from);
    return (<main className='bg-gray-100'>
      <Seo templateTitle='Avatar AI | Create your own AI-generated avatars' description='We use artificial intelligence to generate an image of you that looks perfect and captures who you are. You can be anything, anywhere, or anyone!' image='https://easy-peasy.ai/images/og-ai-avatar.jpg'/>
      <div className='relative overflow-hidden bg-white'>
        <div className='mx-auto'>
          <div className='relative z-10 bg-white pb-8 sm:pb-16 md:pb-20 lg:w-full  lg:pb-28 xl:pb-32'>
            <div className='relative overflow-hidden bg-white'>
              <div className='mx-auto'>
                <LandingPageNavigation />

                <main className='mx-auto mt-10 flex justify-center px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28'>
                  <div className='text-center '>
                    <div className='mb-10'>
                      <span className={clsxm('inline-flex rounded-lg p-3')}>
                        <Image src='/images/avatar.jpeg' alt='Avatar AI for woman' width={150} height={150} className='rounded'/>
                      </span>
                      <span className={clsxm('inline-flex rounded-lg p-3')}>
                        <Image src='/images/9wci2qat4fgm9orpk5x0ve75my6m.jpeg' alt='Avatar AI for man' width={150} height={150} className='rounded'/>
                      </span>
                      <span className={clsxm('inline-flex rounded-lg p-3')}>
                        <Image src='/images/b22ad679-7d36-47c2-8897-48606a45f5f2.webp' alt='Avatar AI' width={150} height={150} className='rounded'/>
                      </span>
                      <span className={clsxm('inline-flex rounded-lg p-3')}>
                        <Image src='/images/8a116ec2-6266-47af-97ba-c010dafe53e2.webp' alt='Avatar AI' width={150} height={150} className='rounded'/>
                      </span>
                    </div>
                    <h1 className={clsxm('text-4xl font-extrabold tracking-tight text-primary-600 sm:text-5xl md:text-6xl')}>
                      <span className='block xl:inline'>AI Avatar</span>{' '}
                    </h1>
                    <p className='mx-auto mt-3 max-w-2xl text-2xl text-gray-500 sm:mt-5 md:mt-5'>
                      Create your own AI-generated avatars in 4K format
                      <br />
                      Works for 🧓 humans, 🐱 cats, 🐶 dogs and 👬 couples
                      <br />
                      Great gift for someones birthday
                    </p>
                    <div className='mt-5 flex flex-col items-center justify-center space-y-5 px-6 sm:mt-8'>
                      <div>
                        <ButtonLink href='/login?avatar=true&price=price_1M6Ek6LgxGi7JA3GHsK7eHpX' variant='dark' className='text-base md:px-10 md:text-lg'>
                          Create 150+ AI Avatars in 4K (4096x4096) — $29
                        </ButtonLink>
                      </div>
                      <div>
                        <ButtonLink href='/login?avatar=true&price=price_1M6EiTLgxGi7JA3GVIarkOlM' variant='primary' className='text-base md:px-10 md:text-lg'>
                          Create 150+ AI Avatars in HD (2048x2048) — $24
                        </ButtonLink>
                      </div>
                      <div>
                        <ButtonLink href='/login?avatar=true&price=price_1M1276LgxGi7JA3G1XFgs5rF' variant='outline' className='text-base md:px-10 md:text-lg'>
                          Create 150+ AI Avatars in SD (512x512) — $19
                        </ButtonLink>
                      </div>
                      {/* <div className='mt-3 sm:mt-0 sm:ml-3'>
    <a
      href='#'
      className='flex w-full items-center justify-center rounded-md border border-transparent bg-primary-100 px-8 py-3 text-base font-medium text-primary-700 hover:bg-primary-200 md:py-4 md:px-10 md:text-lg'
    >
      {' '}
      Live demo{' '}
    </a>
  </div> */}
                    </div>
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='relative mx-auto max-w-4xl md:px-8 xl:px-0'>
        <div className='pt-10 pb-16'>
          <div className='mb-16 px-4 sm:px-6 md:px-0'>
            <div className='mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8'>
              <p className='mt-2 text-3xl font-bold tracking-tight text-primary-600 sm:text-4xl'>
                Example of uploaded photos
              </p>
              <p className='mx-auto mt-5 max-w-prose text-xl text-gray-500'>
                We recommend to upload ~20 photos of yourself to get the best
                results.
              </p>
            </div>
            <ul role='list' className='mt-10 grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8'>
              {[...Array(4)].map((j, i) => (<li key={i} className='relative'>
                  <div className='group aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100'>
                    <img src={`images/original_photo__${i + 1}.jpg`} alt='' className='pointer-events-none object-cover group-hover:opacity-75'/>
                    <button type='button' className='absolute inset-0 focus:outline-none'></button>
                  </div>
                </li>))}
            </ul>
          </div>
          <div className='px-4 sm:px-6 md:px-0'>
            <div className='mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8'>
              <p className='mt-2 text-3xl font-bold tracking-tight text-primary-600 sm:text-4xl'>
                Example of generated avatars
              </p>
              <p className='mx-auto mt-5 max-w-prose text-xl text-gray-500'>
                We use artificial intelligence to generate an image of you that
                looks perfect and captures who you are. You can be anything,
                anywhere, or anyone!
              </p>
            </div>
            <ul role='list' className='mt-10 grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-3 sm:gap-x-6 lg:grid-cols-4 xl:gap-x-8'>
              {[...Array(40)].map((j, i) => (<li key={i} className='relative'>
                  <div className='group aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100'>
                    <img src={`images/${i + 1}.jpeg`} alt='' loading='lazy' className='pointer-events-none object-cover group-hover:opacity-75'/>
                    <button type='button' className='absolute inset-0 focus:outline-none'></button>
                  </div>
                </li>))}
            </ul>
          </div>
        </div>
        <div className='px-6 sm:px-0'>
          <p>
            Upload ~20 photos of yourself (or anything between 4-30). Images
            should include subject in different variations, expressions, poses
            and backgrounds.
          </p>
          <p>
            We recommend uploading 3 photos of full body or entire object + 5
            medium shot photos from the chest up + 10 close ups.
          </p>
          <ul className=' m-5 list-disc'>
            <li>
              To get a variety of shots, change up your body pose, use pictures
              from different days and backgrounds, and show a range of emotions.
            </li>
            <li>
              For each picture, make sure the subject's eyes are looking in a
              different direction.
            </li>
            <li>Every picture should show something new about the subject.</li>
            <li>
              If there's something you don't want to be associated with your
              subject, make sure it's different in every shot.
            </li>
            <li>
              Always choose a new background, even if it's just a small change.
            </li>
          </ul>
          <p className='mt-5'>
            The better you follow these guidelines, the better your avatars:
          </p>
          <ul>
            <li>✅ Photos with different facial expression</li>
            <li>✅ Photos in different locations/backgrounds/angles</li>
            <li>✅ Photos at different times of day</li>
            <li>✅ Look into the camera and also away</li>
            <li>❌ No photo shoots (same setting)</li>
            <li>❌ Not only photos looking INTO the camera</li>
            <li>❌ Not the same expression on every photo</li>
            <li>❌ None or light makeup</li>
            <li>❌ Not multiple people</li>
            <li>❌ No sunglasses</li>
            <li>❌ No nudes</li>
          </ul>
          {/* <p className='my-3'>
          Note: AI can have random results and may sometimes include
          artistic nudes or otherwise shocking images, if you do not want that
          and are sensitive, we recommend you to NOT use this site!
        </p> */}
          <p className='my-3'>
            For your safety: the images you upload are ONLY used to generate
            your AI Avatars. Both the images you upload and the AI model trained
            are auto deleted within 24 hours. Your renders are kept for your
            convenience for 30 days.
          </p>
          <p className='my-3'>
            By using this site you agree to the TOS. We don't allow refunds
            because we incur high GPU costs to generate your pics.
          </p>
          <p className='my-10'>
            After the payment, it'll be about 3-6 hours (based on current
            waiting times) to generate your avatars. We will train the model,
            render your avatars and post-process them. We'll send you an email
            with a link to 100+ different AI avatars of your face when it's
            done!
          </p>
        </div>
        <div className='mb-16 mt-16 flex flex-col items-center justify-center space-y-5 px-6'>
          <div>
            <ButtonLink href='/login?avatar=true&price=price_1M6Ek6LgxGi7JA3GHsK7eHpX' variant='dark' className='text-base md:px-10 md:text-lg'>
              Create 150+ AI Avatars in 4K (4096x4096) — $29
            </ButtonLink>
          </div>
          <div>
            <ButtonLink href='/login?avatar=true&price=price_1M6EiTLgxGi7JA3GVIarkOlM' variant='primary' className='text-base md:px-10 md:text-lg'>
              Create 150+ AI Avatars in HD (2048x2048) — $24
            </ButtonLink>
          </div>
          <div>
            <ButtonLink href='/login?avatar=true&price=price_1M1276LgxGi7JA3G1XFgs5rF' variant='outline' className='text-base md:px-10 md:text-lg'>
              Create 150+ AI Avatars in SD (512x512) — $19
            </ButtonLink>
          </div>
        </div>
      </div>
      {/* <ContactUs /> */}
      <Footer />
    </main>);
};
export default AiAvatar;

    async function __Next_Translate__getStaticProps__1a15314ec06__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-avatar',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a15314ec06__ as getStaticProps }
  